var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.68552 6.01394C5.81345 7.50892 5.25 9.62364 5.25 12C5.25 14.3764 5.81345 16.4911 6.68552 17.9861C7.56834 19.4995 8.67775 20.25 9.75 20.25C10.8223 20.25 11.9317 19.4995 12.8145 17.9861C13.6865 16.4911 14.25 14.3764 14.25 12C14.25 9.62364 13.6865 7.50892 12.8145 6.01394C11.9317 4.50055 10.8223 3.75 9.75 3.75C8.67775 3.75 7.56834 4.50055 6.68552 6.01394ZM5.38986 5.25814C6.40717 3.51417 7.92276 2.25 9.75 2.25C11.5772 2.25 13.0928 3.51417 14.1101 5.25814C15.1382 7.02051 15.75 9.4058 15.75 12C15.75 14.5942 15.1382 16.9795 14.1101 18.7419C13.0928 20.4858 11.5772 21.75 9.75 21.75C7.92276 21.75 6.40717 20.4858 5.38986 18.7419C4.3618 16.9795 3.75 14.5942 3.75 12C3.75 9.4058 4.3618 7.02051 5.38986 5.25814Z",
    fill: "#8395A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 3C9 2.58579 9.33579 2.25 9.75 2.25H14.25C16.0762 2.25 17.5917 3.51492 18.6091 5.25876C19.6375 7.02125 20.25 9.40651 20.25 12C20.25 14.5935 19.6375 16.9787 18.6091 18.7412C17.5917 20.4851 16.0762 21.75 14.25 21.75H9.75C9.33579 21.75 9 21.4142 9 21C9 20.5858 9.33579 20.25 9.75 20.25H14.25C15.3207 20.25 16.4302 19.4993 17.3135 17.9853C18.186 16.49 18.75 14.3753 18.75 12C18.75 9.62474 18.186 7.51 17.3135 6.01468C16.4302 4.5007 15.3207 3.75 14.25 3.75H9.75C9.33579 3.75 9 3.41421 9 3Z",
    fill: "#8395A7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9094 6C12.9094 5.58579 13.2452 5.25 13.6594 5.25H18.1594C18.5736 5.25 18.9094 5.58579 18.9094 6C18.9094 6.41421 18.5736 6.75 18.1594 6.75H13.6594C13.2452 6.75 12.9094 6.41421 12.9094 6Z",
    fill: "#8395A7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.25 12C14.25 11.5858 14.5858 11.25 15 11.25H19.5C19.9142 11.25 20.25 11.5858 20.25 12C20.25 12.4142 19.9142 12.75 19.5 12.75H15C14.5858 12.75 14.25 12.4142 14.25 12Z",
    fill: "#8395A7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9094 18C12.9094 17.5858 13.2452 17.25 13.6594 17.25H18.1594C18.5736 17.25 18.9094 17.5858 18.9094 18C18.9094 18.4142 18.5736 18.75 18.1594 18.75H13.6594C13.2452 18.75 12.9094 18.4142 12.9094 18Z",
    fill: "#8395A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.44c33e59284b0e7b425c253e3e471fb7.svg";
export { ForwardRef as ReactComponent };